import React, { useContext } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Icon,
} from '@mui/material';
import Button from 'components/Button';
import { useModal } from 'components/Modals';
import { DocumentosContext } from 'contexts/DocumentosContext';

const DeleteModal = ({ onSubmit }) => {
  const { closeModal } = useModal();
  const { deleteLoading } = useContext(DocumentosContext);
  const loading = deleteLoading;
  return (
    <>
      <DialogTitle>Confirmar Exclusão</DialogTitle>
      <DialogContent sx={{ textAlign: 'center' }}>
        <DialogContentText>
          <Icon sx={{ fontSize: 150 }}>delete_forever</Icon>
        </DialogContentText>
        <DialogContentText>
          Deseja realmente excluir o registro selecionado?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSubmit} loading={loading}>
          Confirmar
        </Button>
        <Button onClick={closeModal} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default DeleteModal;
